<template>
  <div id="enterprise-table-text">
    <div class="table-text">
      <el-col :span="item.span" v-for="(item, index) in table" :key="index">
        <div class="table-text-item gather">
          <div class="table-text-item-title">
            {{ item.label }}
          </div>
          <div v-if="item.type == 'list'" style="width: 100%;">
            <div
              class="table-text-item-line"
              v-for="(it, ind) in item.list"
              :key="ind"
            >
              <el-col :span="it.labelSpan">
                <div class="table-text-item-list-value">
                  {{ it.label }}
                </div>
              </el-col>
              <el-col :span="it.valueSpan">
                <div class="table-text-item-list-value">
                  {{ it.value || "--" }}
                </div>
              </el-col>
            </div>
          </div>
          <div v-else class="table-text-item-value">
            <div v-if="item.type == 'link'" class="activeColor">
              {{ item.value }}
            </div>
            <div v-if="item.type == 'link_list'">
              <div
                class="activeColor"
                v-for="(it, ind) in item.value"
                :key="ind"
                @click="handleClick(it, 'link_list')"
              >
                {{ it.name }}
              </div>
            </div>
            <div v-else-if="item.type == 'img'" class="activeColor">
              <img
                v-viewer="{ movable: false }"
                class="image"
                :src="item.value"
                alt=""
              />
            </div>
            <div v-else-if="item.type == 'text'">
              {{ item.value || "--" }}
            </div>
          </div>
        </div></el-col
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(item, active) {
      let targetRoute = null;
      switch (active) {
        case "link_list":
          targetRoute = this.$router.resolve({
            name: "Enterprise",
            query: {
              eid: item.name,
            },
          });
          window.open(targetRoute.href, "_blank");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-table-text {
  width: 100%;
  .table-text {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #eff1f8;

    .table-text-item {
      width: 100%;
      height: 100%;
      display: flex;
      font-size: 14px;
      border: 1px solid #eff1f8;
      color: #111a34;
      border-bottom: 0;

      .table-text-item-title {
        background-color: #f9fafc;
        width: 145px;
        min-width: 145px;
        text-align: right;
        padding: 13px 16px;
        box-sizing: border-box;
        color: #777e95;
        border-right: 1px solid #eff1f8;
      }
      .table-text-item-list-value {
        height: 100%;
        padding: 13px 16px;
        box-sizing: border-box;
        text-align: left;
        word-wrap: break-word;
        word-break: normal;
        max-height: 200px;
        overflow: auto;
        .image {
          height: 32px;
          width: auto;
          object-fit: contain;
          border-radius: 3px;
        }
      }
      .table-text-item-value {
        width: 80%;
        height: 100%;
        padding: 13px 16px;
        box-sizing: border-box;
        text-align: left;
        word-wrap: break-word;
        word-break: normal;
        max-height: 200px;
        overflow: auto;
        .image {
          height: 32px;
          width: auto;
          object-fit: contain;
          border-radius: 3px;
        }
      }
    }
    .gather {
      .table-text-item-line {
        display: flex;
        &:last-child .table-text-item-list-value {
          border-bottom: 0;
        }
        .table-text-item-list-value {
          border-right: 1px solid #eff1f8;
          border-bottom: 1px solid #eff1f8;
          &:nth-child(even) {
            border-right: 0;
          }
        }
      }
    }
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
}
</style>
